import { ColorPickerWithDefault } from '../../../../components/inputs/ColorPickerWithDefault';
import { useViewColorValue } from '../../hooks/view-forms';

const DEFAULT_OVERWATER_COLOR = '#4169e1b3';

export function OverwaterAreasSettings() {
    const color = useViewColorValue((v) => v.staticData.overwaterAreas.lineColor ?? DEFAULT_OVERWATER_COLOR);

    return (
        <div className="d-flex flex-column gap-2 px-3 py-2 overflow-auto" style={{ width: '320px' }}>
            <div className="d-flex align-items-center gap-2">
                <div>Color</div>
                <ColorPickerWithDefault {...color} defaultColor={DEFAULT_OVERWATER_COLOR} />
            </div>
        </div>
    );
}
